const t = {
  name: "Display",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 2C1.34315 2 0 3.34315 0 5V15C0 16.6569 1.34315 18 3 18H21C22.6569 18 24 16.6569 24 15V5C24 3.34315 22.6569 2 21 2H3ZM2 5C2 4.44772 2.44772 4 3 4H21C21.5523 4 22 4.44772 22 5V15C22 15.5523 21.5523 16 21 16H3C2.44772 16 2 15.5523 2 15V5Z" fill="currentColor"/>
<path d="M17 20H7V22H17V20Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Display
};
